import { updateSelectedCalendarViewInStore } from '../actions/internalActions';
import { workloadScenarioSettingsLoaded } from 'owa-scenario-settings';
import { getUserPrimarySmtpAddress } from 'owa-session-store';
import { orchestrator } from 'satcheljs';

export const workloadScenarioSettingsLoadedOrchestrator = orchestrator(
    workloadScenarioSettingsLoaded,
    actionMessage => {
        const { settings, accountSmtpAddress } = actionMessage;
        if (
            getUserPrimarySmtpAddress() === accountSmtpAddress &&
            settings.timePanelSelectedCalendarView
        ) {
            updateSelectedCalendarViewInStore(settings.timePanelSelectedCalendarView);
        }
    }
);
